import { FC } from "react";

import { SATOSContentRender } from "@/components/Application/SATOSContentRender";
import { IChecklistStep } from "@/components/Procedures/Checklist/utils/Types";

import {
	useFetchActiveProcedureDetails,
	useHandleProcedureDetails,
} from "@/service/ProcedureQueries";

export const StepContent: FC<IChecklistStep> = (props) => {
	const { data: ProcedureDetails } = useFetchActiveProcedureDetails();

	const { activeChildNode } = useHandleProcedureDetails(
		ProcedureDetails?.ProcedureDetailNodes,
		props.activeSchemeId,
	);

	if (activeChildNode?.ImportedChecklist && !props.materialHandling) {
		return <SATOSContentRender content={props.step.Value} />;
	}

	return (
		<>
			<SATOSContentRender content={props.step.Value} />
		</>
	);
};
